/**
 * User + Config panels — read-only views of the two other payloads serialized
 * to the client at bootstrap: the authenticated user (redux `state.user`, from
 * `window.INITIAL_STATE`) and the app's global config (`window.CONFIGS`, from
 * foundation's html template). Feature flags get their own interactive panel.
 */
import React from 'react'
import { useSelector } from 'react-redux'
import { JsonView } from './JsonView'

interface StoreShape {
  user?: Record<string, unknown>
}

export const UserPanel: React.FC = () => {
  const user = useSelector((s: StoreShape) => s.user)
  return <JsonView data={user} />
}

/** Global config serialized by foundation as `window.CONFIGS`. */
function readConfigs(): Record<string, unknown> | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as { CONFIGS?: Record<string, unknown> }).CONFIGS
}

export const ConfigPanel: React.FC = () => {
  return <JsonView data={readConfigs()} />
}
